export const Sort = () => (
  <svg
    width="10"
    height="13"
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.42787 4.54538L3.42787 3.48471L6.60985 0.302734L9.79183 3.48471V4.54537H7.35985V6.22736H5.85985L5.85985 4.54537L3.42787 4.54538Z"
      fill="white"
    />
    <path
      d="M6.79182 7.98471L6.79182 9.04537L3.60984 12.2274L0.427856 9.04538V7.98472H2.85984L2.85984 6.30273H4.35984L4.35984 7.98471L6.79182 7.98471Z"
      fill="white"
    />
  </svg>
);
